var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.64513V5.551C5 3.43076 5 2.37064 5.67965 1.77328C6.35931 1.17591 7.41066 1.31197 9.51337 1.58408L16.77 2.52318C19.2611 2.84556 20.5067 3.00675 21.2533 3.85626C22 4.70577 22 5.9617 22 8.47356V15.5264C22 18.0383 22 19.2942 21.2533 20.1437C20.5067 20.9933 19.2611 21.1544 16.77 21.4768L9.51337 22.4159C7.41066 22.688 6.35931 22.8241 5.67965 22.2267C5 21.6294 5 20.5692 5 18.449V17.5726",
    stroke: "#1DC071",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12L15.8107 11.4145L16.2335 12L15.8107 12.5855L15 12ZM1 13C0.447715 13 0 12.5523 0 12C0 11.4477 0.447715 11 1 11V13ZM11.4773 5.41451L15.8107 11.4145L14.1893 12.5855L9.85599 6.58549L11.4773 5.41451ZM15.8107 12.5855L11.4773 18.5855L9.85599 17.4145L14.1893 11.4145L15.8107 12.5855ZM15 13H1V11H15V13Z",
    fill: "#1DC071"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutLogo);
export default __webpack_public_path__ + "static/media/logoutLogo.5d569ae321cd0588cb621851e8324f5e.svg";
export { ForwardRef as ReactComponent };